import { useSession } from "next-auth/react";
import { useEffect, useMemo, useState } from "react";
import { handleStrategyAlarmClick } from "utils/alarm/strategy";
import { useRouter } from "next/router";
import { STRATEGY_TYPE } from "utils/constant/STATUS";
import CustomToast from "components/atoms/CustomToast";
import { TYPO } from "styles/Typo";
import Button from "components/common/buttons/buttons";
import { useStrategyAlarm } from "lib/analytics/react/hooks";

function StrategyAlarmRegister({
  sCode,
  init,
  setInit,
}: {
  sCode: STRATEGY_TYPE;
  init: boolean;
  setInit: (init: boolean) => void;
}) {
  const router = useRouter();
  const [heightAnimation, setHeightAnimation] = useState(false);
  const [height, setHeight] = useState(0);
  const strategyAlarm = useStrategyAlarm();

  const { data: session, update }: any = useSession();
  const [alarmToastVisible, setAlarmToastVisible] = useState(false);
  const isLoginUser = session?.user?.email || false;
  const isStrategyAlarmOn = session?.user?.strategyAlarmOnOff;
  const isAlarmRegistered = useMemo(() => {
    if (session && session.user) {
      return session?.user?.strategyAlarm.includes(sCode);
    }
  }, [session]);
  console.log("init", init);

  useEffect(() => {
    if (!init) {
      const viewStrategyAlarmCTA = localStorage.getItem("viewStrategyAlarmCTA");
      if (viewStrategyAlarmCTA) {
        if (
          new Date().getTime() - new Date(viewStrategyAlarmCTA).getTime() <
          1000 * 60 * 60 * 24
        )
          return;
      }
      setHeightAnimation(true);
    }
  }, [init]);

  useEffect(() => {
    if (heightAnimation) {
      const viewStrategyAlarmCTA = localStorage.getItem("viewStrategyAlarmCTA");
      if (viewStrategyAlarmCTA) {
        if (
          new Date().getTime() - new Date(viewStrategyAlarmCTA).getTime() >
          1000 * 60 * 60 * 24
        )
          localStorage.removeItem("viewStrategyAlarmCTA");
        else return;
      }

      setTimeout(() => {
        setHeight(100);

        setTimeout(() => {
          setInit(true);
          localStorage.setItem(
            "viewStrategyAlarmCTA",
            new Date().toISOString()
          );
        }, 600);
      }, 300);
    }
  }, [heightAnimation]);

  // 알림 등록
  const registerAlarm = async () => {
    if (!isAlarmRegistered) {
      strategyAlarm.start({
        strategy_id: sCode,
        market: sCode?.includes("us") ? "us" : "kr",
        from_section_id: "strategy_banner_next_month_alert",
      });
    }
    window.dataLayer.push({
      event: "cStratAlarmTop",
    });
    if (!isLoginUser) {
      notLoginUserCallback();
      return;
    }
    await handleStrategyAlarmClick({
      session,
      update,
      router,
      isAlarmRegistered,
      sCode,
      setAlarmToastVisible,
      success: strategyAlarm.success,
      fail: strategyAlarm.fail,
    });

    // 알림 등록 후 삭제
    const isRegistered = localStorage.getItem(`strategyAlarmRegister:${sCode}`);
    if (isRegistered) {
      localStorage.removeItem(`strategyAlarmRegister:${sCode}`);
    }
  };
  const notLoginUserCallback = () => {
    router.push(`/login?from=${router.asPath}`);

    // 비로그인 유저 -> 로그인 후 자동 알림 등록
    localStorage.setItem(
      `strategyAlarmRegister:${sCode}`,
      new Date().toISOString()
    );
  };
  useEffect(() => {
    // 비로그인 유저 -> 로그인 후 자동 알림 등록
    if (isLoginUser) {
      const isRegistered = localStorage.getItem(
        `strategyAlarmRegister:${sCode}`
      );
      // 1시간 이상 지났으면 삭제
      if (
        isRegistered &&
        new Date().getTime() - new Date(isRegistered).getTime() > 1000 * 60 * 60
      ) {
        localStorage.removeItem(`strategyAlarmRegister:${sCode}`);
        return;
      }

      if (isRegistered && !isAlarmRegistered) {
        // 알림 자동 등록
        registerAlarm();
      }
    }
  }, [isLoginUser]);

  if (isAlarmRegistered)
    return (
      <CustomToast
        successIconFill={"#34BB7A"}
        message={
          router.locale == "ko" && isAlarmRegistered
            ? "이제부터 문자로 알림을 받아요"
            : isAlarmRegistered &&
              router.locale !== "ko" &&
              "Successfully Alarm Registered"
        }
        isVisible={alarmToastVisible && isAlarmRegistered}
        onClose={() => {
          setAlarmToastVisible(false);
        }}
        width={router.locale === "ko" ? 245 : 275}
        duration={2000}
      />
    );
  return (
    <>
      <div
        className="w-full overflow-hidden"
        style={{
          transition: "max-height 0.6s ease-in-out",
          maxHeight:
            typeof window !== "undefined" &&
            localStorage.getItem("viewStrategyAlarmCTA") &&
            new Date().getTime() -
              new Date(
                localStorage.getItem("viewStrategyAlarmCTA") || ""
              ).getTime() <
              1000 * 60 * 60 * 24
              ? "auto"
              : !heightAnimation
              ? init
                ? "auto"
                : "0px"
              : `${height}px`,
          transformOrigin: "top",
        }}
      >
        <div className="flex px-6 py-4 justify-between items-center bg-blue5">
          <div className="flex flex-col">
            <p className={`${TYPO.TYPO7_1_RG} text-gray60`}>
              다음달 종목이 공개되면
            </p>
            <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
              가장 먼저 알려드릴게요
            </p>
          </div>
          <Button
            type={"primary"}
            size={"md"}
            text={"알림 받기"}
            clickHandler={registerAlarm}
            dataGtmId="stAlarmRegister"
          />
        </div>
      </div>
      <CustomToast
        successIconFill={"#34BB7A"}
        message={
          router.locale == "ko" && isAlarmRegistered
            ? "이제부터 문자로 알림을 받아요"
            : isAlarmRegistered &&
              router.locale !== "ko" &&
              "Successfully Alarm Registered"
        }
        isVisible={alarmToastVisible && isAlarmRegistered}
        onClose={() => {
          setAlarmToastVisible(false);
        }}
        width={router.locale === "ko" ? 245 : 275}
        duration={2000}
      />
    </>
  );
}

export default StrategyAlarmRegister;
